import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/public/Header";
import Footer from "@/components/public/Footer";
import ChatWidget from "@/components/public/ChatWidget";
import api from "@/lib/api";

export default function PublicLayout() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    let vid = localStorage.getItem("aj_vid");
    if (!vid) { vid = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random()); localStorage.setItem("aj_vid", vid); }
    api.post("/analytics/track", { path: loc.pathname, referrer: document.referrer, visitor_id: vid }).catch(() => {});
  }, [loc.pathname]);

  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <main><Outlet /></main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
